/**
 * 휴대폰 번호 입력 — 숫자만 받고 대시는 화면이 붙인다. 서버·인증 대조는 숫자만 본다(normalizePhone · normalizeFor).
 *
 *   010          3-4-4  (늘 11자리 — 치는 동안에도 3-4-4 로 끊어 대시가 튀지 않는다)
 *   011·016~019  10자리 3-3-4, 11자리 3-4-4
 *   +82 10-…     → 010-…  (국가번호로 붙여넣은 경우)
 */

/** 입력값의 숫자만, 최대 11자리. 국가번호(+82)로 시작하면 0 으로 바꾼다 */
export function phoneDigits(raw: string): string {
  let d = raw.replace(/\D/g, '');
  if (/^\s*\+?\s*82/.test(raw) && d.startsWith('82')) d = `0${d.slice(2)}`;
  return d.slice(0, 11);
}

export function formatPhone(digits: string): string {
  const d = digits.slice(0, 11);
  const long = d.startsWith('010') || d.length === 11; // 3-4-4
  const mid = long ? 7 : 6;
  if (d.length <= 3) return d;
  if (d.length <= mid) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, mid)}-${d.slice(mid)}`;
}

/** 포맷한 문자열에서 앞에서부터 숫자 n 개가 끝나는 위치 — 커서를 숫자 기준으로 되돌린다 */
export function caretAfterDigits(formatted: string, n: number): number {
  if (n <= 0) return 0;
  let seen = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i]!)) seen++;
    if (seen === n) return i + 1;
  }
  return formatted.length;
}

/**
 * 입력 이벤트 하나를 반영한다. 대시 바로 뒤에서 지우기(←)를 누르면 대시만 지워져 곧바로 다시 붙는다 —
 * 그때는 그 앞 숫자를 지운다(지우기가 먹히지 않는 느낌을 없앤다).
 */
export function applyPhoneInput(
  prev: string,
  raw: string,
  caret: number,
  deleteBackward: boolean,
): { value: string; caret: number } {
  let digits = phoneDigits(raw);
  let digitsBeforeCaret = raw.slice(0, caret).replace(/\D/g, '').length;
  if (deleteBackward && digits === prev.replace(/\D/g, '') && digitsBeforeCaret > 0) {
    digits = digits.slice(0, digitsBeforeCaret - 1) + digits.slice(digitsBeforeCaret);
    digitsBeforeCaret -= 1;
  }
  const value = formatPhone(digits);
  return { value, caret: caretAfterDigits(value, Math.min(digitsBeforeCaret, digits.length)) };
}
